export { Collapse } from './collapse';
export type { CollapseProps } from './collapse';
